import React, { useState } from 'react';

import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Input from 'components/shared/Input/Input';

const SavePopupContent = ({ onClose = () => {}, onSaveForms, removeClose = false }) => {
  const [inputValue, setInputValue] = useState('');

  const closePopup = () => {
    onClose();
  };

  const onInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const onSave = () => {
    onSaveForms(inputValue);
    setInputValue('');
  };

  return (
    <div className="flex w-[230px] flex-col gap-3 !pr-2">
      <Input
        value={inputValue}
        label="Order name"
        data-qa="order-name"
        onChange={onInputChange}
        placeholder="Enter order name..."
      />
      <div className={cn('flex justify-between', removeClose && '!ml-auto')}>
        {!removeClose && (
          <Button
            onClick={closePopup}
            style="outlined"
            color="neutral"
            variant="tertiary"
            text="Cancel"
            data-qa="cancel"
            size="small"
          />
        )}
        <Button
          onClick={onSave}
          text="Save"
          size="small"
          icon="save-mono"
          data-qa="save"
          isDisabled={!inputValue.trim()?.length}
        />
      </div>
    </div>
  );
};

export default SavePopupContent;
